import { render, staticRenderFns } from "./resetpassword.vue?vue&type=template&id=4af05a72&"
import script from "./resetpassword.vue?vue&type=script&lang=js&"
export * from "./resetpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports